/* Native Shopify Forms are the first and only submission surface. */
(() => {
  'use strict';
  const initialized = new WeakSet();
  const watchedHosts = new WeakSet();
  const enhancedRoots = new WeakSet();
  const attachmentStates = new WeakMap();
  const messageStates = new WeakMap();
  const trustInitialized = new WeakSet();
  const dateStates = new WeakSet();
  const formStyles = `
    form[data-testid="form"] + [class*="_formDisclaimer_"] {display:none!important}
    :host {--forms-inline-max-width:100%!important;--inline-container-max-width:100%!important}
    :host,section:has(form[data-testid="form"]) {overflow:visible!important}
    section:has(form[data-testid="form"]),form[data-testid="form"] {width:100%!important;max-width:none!important}
    section[class]:has(>h2):has(+form) {display:none!important}
    form[data-testid="form"] {display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:26px 18px!important;align-items:start;padding:0!important}
    form[data-testid="form"] > * {grid-column:1/-1;min-width:0}
    form[data-testid="form"] > [data-reischl-field] {grid-column:auto;display:flex!important;flex-direction:column!important;gap:8px!important;margin:0!important;padding:0!important;min-width:0}
    form[data-testid="form"] > [data-reischl-field="message"] {grid-column:1/-1}
    form[data-testid="form"] > div:has(>shop-lead-capture[proxy="true"]) {display:none!important}
    form[data-testid="form"] [data-reischl-field] > label,
    form[data-testid="form"] [data-reischl-field] > p[id$="-selector-label"],
    form[data-testid="form"] [data-reischl-field="phone"] label[for] {
      position:static!important;inset:auto!important;transform:none!important;transition:none!important;
      display:block!important;order:-1;box-sizing:border-box;width:100%!important;max-width:none!important;
      min-height:24px!important;height:auto!important;margin:0!important;padding:0!important;
      font:400 15px/24px Arial,sans-serif!important;color:#30343b!important;background:transparent!important;
      overflow:visible!important;pointer-events:auto!important
    }
    form[data-testid="form"] [data-reischl-field] > input:not([type="file"]),
    form[data-testid="form"] [data-reischl-field] > textarea,
    form[data-testid="form"] [data-reischl-field] > button[aria-expanded],
    form[data-testid="form"] [data-reischl-field="phone"] input,
    form[data-testid="form"] .phone-country-selector button {
      display:block;box-sizing:border-box!important;width:100%!important;min-width:0!important;
      height:44px!important;min-height:44px!important;max-height:44px!important;
      padding:10px 11px!important;margin:0!important;border:1px solid #85868d!important;border-radius:4px!important;
      background:#fff!important;color:#30343b!important;font:400 16px/22px Arial,sans-serif!important;box-shadow:none!important
    }
    form[data-testid="form"] [data-reischl-field] > button[aria-expanded],
    form[data-testid="form"] .phone-country-selector button {display:flex!important;align-items:center;justify-content:space-between}
    form[data-testid="form"] > [data-reischl-field="message"]::before {display:none!important}
    form[data-testid="form"] [data-reischl-field] > textarea {height:112px!important;min-height:112px!important;max-height:none!important;resize:vertical}
    form[data-testid="form"] [data-reischl-field] > input[type="date"] {color-scheme:light}
    form[data-testid="form"] > [data-reischl-field="phone"] {display:grid!important;grid-template-columns:64px minmax(0,1fr)!important;grid-template-rows:24px 44px;gap:8px 6px!important;width:100%!important}
    form[data-testid="form"] [data-reischl-field="phone"] > div:has(>input[type="tel"]) {display:contents!important}
    form[data-testid="form"] [data-reischl-field="phone"] label[for] {grid-column:1/-1;grid-row:1}
    form[data-testid="form"] .phone-country-selector {grid-column:1;grid-row:2;align-self:stretch}
    form[data-testid="form"] .phone-country-selector > div {height:100%}
    form[data-testid="form"] .phone-country-selector button {padding:10px 8px!important}
    form[data-testid="form"] [data-reischl-field="phone"] input {grid-column:2;grid-row:2}
    form[data-testid="form"] [data-reischl-field="phone"] output {grid-column:1/-1;grid-row:3}
    form[data-testid="form"] input[aria-invalid="true"] {border-color:#b42318!important}
    form[data-testid="form"] input:focus-visible,form[data-testid="form"] textarea:focus-visible,form[data-testid="form"] button:focus-visible {outline:2px solid #1d4e89!important;outline-offset:2px}
    form[data-testid="form"] [id$="-selector-dropdown"] {min-width:100%;max-width:none}
    form[data-testid="form"] div:has(>[data-reischl-menu]) {z-index:5}
    [data-reischl-menu] {z-index:10!important;min-width:100%;max-width:calc(100vw - 48px)}
    [data-reischl-menu],[data-reischl-menu]>[id$="-selector-dropdown"] {max-height:min(var(--reischl-menu-height,420px),calc(100dvh - 120px))!important}
    [data-reischl-menu]>[id$="-selector-dropdown"] {overflow-y:auto;overscroll-behavior:contain}
    [data-reischl-menu-direction="down"] {top:calc(100% + 4px)!important;bottom:auto!important}
    [data-reischl-menu-direction="up"] {top:auto!important;bottom:calc(100% + 4px)!important}
    .reischl-attachment-disclosure {display:flex;align-items:center;gap:10px;min-height:44px;margin:0;padding:20px 0 0;border-top:1px solid #e5e5e5;cursor:pointer;font:400 15px/1.5 Arial,sans-serif;color:#30343b}
    .reischl-attachment-disclosure input {appearance:auto;flex:none;width:18px;height:18px;margin:0;accent-color:#d67d28;cursor:pointer}
    .reischl-attachment-disclosure input:focus-visible {outline:2px solid #1d4e89;outline-offset:3px}
    form > [data-reischl-attachment-row] {display:grid;grid-template-columns:90px minmax(0,1fr);gap:12px;align-items:center}
    form > [data-reischl-attachment-row] > p {margin:0;font:400 15px/1.4 Arial,sans-serif}
    form > [data-reischl-attachment-row] > div {min-height:44px;margin:0;padding:6px 12px;border-radius:4px}
    form > [data-reischl-attachment-row][hidden] {display:none!important}
    form[data-testid="form"] > button[type="submit"] {grid-column:1/-1;justify-self:center;width:auto;min-width:220px;min-height:48px;border-radius:4px!important;background:#d67d28!important;color:#fff!important;font:600 16px/1.4 Arial,sans-serif!important;padding:12px 28px!important}
    @media(max-width:999px) {form[data-testid="form"] {grid-template-columns:repeat(2,minmax(0,1fr))!important}}
    @media(max-width:599px) {
      form[data-testid="form"] {grid-template-columns:minmax(0,1fr)!important;gap:20px!important}
      form[data-testid="form"] > * {grid-column:1/-1!important}
      form[data-testid="form"] > button[type="submit"] {width:100%;min-width:0}
    }
    form[data-testid="form"] > [data-reischl-field][hidden] {display:none!important}
    form[data-testid="form"] > .reischl-form-options {display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px;border-top:1px solid #e2e2e2;padding-top:32px;margin-top:0}
    .reischl-attachment-disclosure {border:0;padding:0;align-items:flex-start;font-size:16px;line-height:22px;min-height:28px}
    .reischl-attachment-disclosure input {margin-top:1px;width:20px;height:20px}
    form[data-testid="form"] > [data-reischl-field="consent"] {grid-column:1/-1;display:block!important;margin-top:0!important}
    form[data-testid="form"] [data-reischl-field="consent"] p {font:400 17px/1.45 Arial,sans-serif!important;margin:0 0 20px!important}
    form[data-testid="form"] [data-reischl-field="consent"] label {display:flex!important;align-items:flex-start!important;gap:12px!important;font:400 16px/1.4 Arial,sans-serif!important;max-width:850px}
    form[data-testid="form"] [data-reischl-field="consent"] input {flex:none;width:20px!important;height:20px!important;min-height:20px!important;margin:2px 0 0!important;accent-color:#d67d28}
    form[data-testid="form"] > button[type="submit"] {box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;width:334px;max-width:100%;height:auto!important;min-height:48px!important;border-radius:40px!important;font:400 18px/24px Arial,sans-serif!important;margin-top:28px!important}
    @media(max-width:999px) {form[data-testid="form"] > .reischl-form-options {grid-template-columns:repeat(2,minmax(0,1fr))}}
    @media(max-width:599px) {form[data-testid="form"] > .reischl-form-options {grid-template-columns:1fr;gap:18px;padding-top:24px}form[data-testid="form"] > button[type="submit"] {width:100%}}
    form[data-testid="form"] [data-reischl-field="consent"] legend {font:400 17px/1.45 Arial,sans-serif!important;margin:0 0 20px!important;padding:0!important}
    [data-reischl-field="service"] > p::after,
    [data-reischl-field="email"] > label::after,
    [data-reischl-field="name"] > label::after,
    [data-reischl-field="lastname"] > label::after,
    [data-reischl-field="city"] > label::after,
    [data-reischl-field="consent"] legend::after {content:" *";color:#d92d20}
    .reischl-field-hint,.reischl-phone-hints {font:400 13px/18px Arial,sans-serif;color:#68738b}
    .reischl-phone-hints {grid-column:1/-1;grid-row:3;display:grid;grid-template-columns:64px minmax(0,1fr);gap:6px}
    form[data-testid="form"] [data-reischl-field="phone"] output {grid-row:4}
  `;

  function arrangeFields(form) {
    const fields = [
      ['service', 'button[aria-labelledby^="custom#gewnschte_leistung-selector-label"]'],
      ['company', 'input[id="custom#firma_optional"]'],
      ['email', 'input[id="email"]'],
      ['phone', 'input[type="tel"]'],
      ['name', 'input[id="first_name"]'],
      ['lastname', 'input[id="last_name"]'],
      ['street', 'input[id="custom#strae_hausnummer_optional"]'],
      ['city', 'input[id="custom#ort"]'],
      ['message', 'textarea[id="custom#anfragedetails"]'],
      ['consent', 'input[type="checkbox"][id^="custom#datenbermittlung_datenspeicherung"]']
    ];
    fields.forEach(([name, selector]) => {
      const control = form.querySelector(selector);
      if (!control) return;
      let row = control.parentElement;
      while (row && row.parentElement !== form) row = row.parentElement;
      if (row) {
        row.dataset.reischlField = name;
        if (['service','email','name','lastname','city','consent'].includes(name)) control.setAttribute('aria-required','true');
        if (name === 'email' && !row.querySelector('.reischl-field-hint')) {
          const hint = document.createElement('span');
          hint.className = 'reischl-field-hint';
          hint.textContent = 'beispiel@beispiel.de';
          row.append(hint);
        }
        if (name === 'phone' && !row.querySelector('.reischl-phone-hints')) {
          const hint = document.createElement('div');
          hint.className = 'reischl-phone-hints';
          ['Vorwahl','Telefonnummer'].forEach(text => {const span = document.createElement('span'); span.textContent = text; hint.append(span);});
          row.append(hint);
        }
      }
    });
  }

  function arrangeReferenceLayout(form, rows) {
    let options = form.querySelector('.reischl-form-options');
    if (!options) {
      options = document.createElement('div');
      options.className = 'reischl-form-options';
      form.append(options);
    }
    const attachment = attachmentStates.get(form);
    if (attachment && attachment.control.parentElement !== options) options.append(attachment.control);
    const message = form.querySelector('[data-reischl-field="message"]');
    if (message) {
      let state = messageStates.get(form);
      if (!state) {
        const control = document.createElement('label');
        control.className = 'reischl-attachment-disclosure';
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        const caption = document.createElement('span');
        caption.textContent = 'Nachricht hinzufügen (optional)';
        control.append(checkbox, caption);
        state = {control, checkbox};
        messageStates.set(form, state);
        checkbox.addEventListener('change', () => {
          message.hidden = !checkbox.checked;
          checkbox.setAttribute('aria-expanded', String(checkbox.checked));
        });
      }
      if (!message.id) message.id = 'reischl-optional-message';
      state.checkbox.setAttribute('aria-controls', message.id);
      state.checkbox.setAttribute('aria-expanded', String(state.checkbox.checked));
      message.hidden = !state.checkbox.checked;
      if (state.control.parentElement !== options) options.append(state.control);
    }
    const ordered = ['service','company','email','phone','name','lastname','street','city']
      .map(key => form.querySelector('[data-reischl-field="' + key + '"]')).filter(Boolean);
    ordered.push(options);
    if (message) ordered.push(message);
    ordered.push(...rows);
    const consent = form.querySelector('[data-reischl-field="consent"]');
    if (consent) ordered.push(consent);
    const submit = form.querySelector('button[type="submit"]');
    const current = [...form.children].filter(row => ordered.includes(row));
    if (ordered.some((row, i) => row !== current[i])) ordered.forEach(row => form.insertBefore(row, submit));
  }

  function enhanceDateFields(shadow, form) {
    const input = form.querySelector('input[id="custom#wunschtermin"]');
    if (!input) return;
    input.type = 'date';
    if (input.type !== 'date') return;
    input.lang = 'de-DE';
    input.removeAttribute('inputmode');
    input.parentElement.dataset.reischlDateControl = '';
    if (dateStates.has(input)) return;
    dateStates.add(input);
    form.addEventListener('submit', event => {
      if (input.validity.valid) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
    }, true);
  }
  function enhanceNativeControls(shadow) {
    if (enhancedRoots.has(shadow)) return;
    enhancedRoots.add(shadow);
    const update = () => {
      shadow.host.toggleAttribute('data-reischl-menu-open', !!shadow.querySelector('[id$="-selector-dropdown"]'));
      const form = shadow.querySelector('form[data-testid="form"]');
      if (!form) return;
      enhanceDateFields(shadow, form);
      arrangeFields(form);
      const rows = [...form.children].filter(row => row.querySelector('input[type="file"][id^="custom#foto_oder_pdf_"]'));
      if (rows.length) {
        let state = attachmentStates.get(form);
        if (!state) {
          const control = document.createElement('label');
          control.className = 'reischl-attachment-disclosure';
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.id = 'reischl-attachments-toggle';
          checkbox.title = 'Anhangsfelder ein- oder ausblenden. Bereits ausgewählte Dateien bleiben beim Einklappen erhalten.';
          const caption = document.createElement('span');
          caption.textContent = 'Fotos, Dateien, Pläne hinzufügen (optional)';
          control.append(checkbox, caption);
          state = { control, checkbox };
          attachmentStates.set(form, state);
          checkbox.addEventListener('change', update);
        }
        rows.forEach((row, index) => {
          if (!row.id) row.id = 'reischl-attachment-row-' + (index + 1);
          row.dataset.reischlAttachmentRow = '';
          row.hidden = !state.checkbox.checked;
        });
        state.checkbox.setAttribute('aria-controls', rows.map(row => row.id).join(' '));
        state.checkbox.setAttribute('aria-expanded', String(state.checkbox.checked));

      }
      arrangeReferenceLayout(form, rows);
      ['custom#gewnschte_leistung', 'custom#was_soll_gereinigt_werden', 'custom#gewnschter_rhythmus'].forEach(key => {
        const list = shadow.getElementById(key + '-selector-dropdown');
        const button = shadow.querySelector('[aria-labelledby^="' + key + '-selector-label"]');
        if (!list || !button) return;
        const container = list.parentElement;
        const view = button.ownerDocument.defaultView;
        const viewport = view.visualViewport;
        const viewportTop = viewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (viewport?.height || view.innerHeight);
        let ceiling = viewportTop + 12;
        button.ownerDocument.querySelectorAll('header').forEach(header => {
          const rect = header.getBoundingClientRect();
          if (rect.top <= viewportTop + 2 && rect.bottom > viewportTop && ['fixed', 'sticky'].includes(view.getComputedStyle(header).position)) ceiling = Math.max(ceiling, rect.bottom + 12);
        });
        const bounds = button.getBoundingClientRect();
        const above = Math.max(0, bounds.top - ceiling - 4);
        const below = Math.max(0, viewportBottom - bounds.bottom - 16);
        const down = below >= Math.min(420, above);
        const height = Math.max(44, Math.min(420, down ? below : above));
        container.dataset.reischlMenu = '';
        container.dataset.reischlMenuDirection = down ? 'down' : 'up';
        container.style.setProperty('--reischl-menu-height', height + 'px');
      });
    };
    const observer = new MutationObserver(update);
    observer.observe(shadow, { childList:true, subtree:true });
    update();
  }
  function adaptNativeForm(host, service) {
    if (watchedHosts.has(host)) return;
    watchedHosts.add(host);
    customElements.whenDefined('shopify-forms-embed').then(() => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      let selectionStarted = false;
      let userInteracted = false;
      let finished = false;
      let observer;
      let savedViewport = null;
      let savedFocus = null;
      let viewportInteracted = false;
      ['wheel', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, () => { viewportInteracted = true; }, { once:true, passive:true, capture:true }));
      const restoreViewport = () => {
        if (!savedViewport || userInteracted || viewportInteracted || location.hash) return;
        shadow.activeElement?.blur();
        if (savedFocus?.isConnected && savedFocus !== host) savedFocus.focus({ preventScroll:true });
        window.scrollTo({ ...savedViewport, behavior:'instant' });
      };
      const restoreAfterSelection = () => {
        restoreViewport();
        requestAnimationFrame(() => { restoreViewport(); requestAnimationFrame(restoreViewport); });
      };
      const stop = () => { finished = true; observer?.disconnect(); clearTimeout(timeout); };
      const update = () => {
        if (finished || !shadow.querySelector('form')) return;
        if (!shadow.getElementById('reischl-native-form-styles')) {
          const style = document.createElement('style');
          style.id = 'reischl-native-form-styles';
          style.textContent = formStyles;
          shadow.append(style);
        }
        enhanceNativeControls(shadow);
        if (!service || userInteracted) { stop(); return; }
        const value = shadow.getElementById('custom#gewnschte_leistung-selector-value');
        const button = shadow.querySelector('[aria-labelledby^="custom#gewnschte_leistung-selector-label"]');
        if (!button || !value) return;
        if (value.textContent.trim()) { stop(); return; }
        // Select through Forms' own controls so its state and submission agree.
        if (!selectionStarted) {
          selectionStarted = true;
          savedViewport = { top:window.scrollY, left:window.scrollX };
          savedFocus = document.activeElement;
          button.click();
          restoreAfterSelection();
        }
        const option = shadow.getElementById('select-custom#gewnschte_leistung-' + service);
        if (option) { option.click(); restoreAfterSelection(); stop(); }
        else if (shadow.getElementById('custom#gewnschte_leistung-selector-dropdown')) {
          if (button.getAttribute('aria-expanded') === 'true') button.click();
          restoreAfterSelection();
          stop();
        }
      };
      shadow.addEventListener('pointerdown', () => { userInteracted = true; stop(); }, { once:true, capture:true });
      shadow.addEventListener('keydown', event => { if (event.isTrusted) { userInteracted = true; stop(); } }, { once:true, capture:true });
      const timeout = setTimeout(stop, 15000);
      observer = new MutationObserver(update);
      observer.observe(shadow, { childList:true, subtree:true });
      update();
    });
  }
  function initializeTrustStrips(root) {
    root.querySelectorAll('[data-reischl-trust-carousel]').forEach(wrapper => {
      if (trustInitialized.has(wrapper)) return;
      trustInitialized.add(wrapper);
      const track = wrapper.querySelector('.reischl-trust-strip');
      const buttons = [...wrapper.querySelectorAll('[data-reischl-trust-index]')];
      if (!track || !buttons.length) return;
      let frame = 0;
      const synchronize = () => {
        frame = 0;
        const index = Math.max(0, Math.min(buttons.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
        buttons.forEach((button, position) => button.setAttribute('aria-current', String(position === index)));
      };
      track.addEventListener('scroll', () => {
        if (!frame) frame = requestAnimationFrame(synchronize);
      }, { passive:true });
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        track.scrollTo({ left:track.clientWidth * index, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      }));
      synchronize();
    });
  }
  function initialize(root = document) {
    initializeTrustStrips(root);
    const wrappers = [...root.querySelectorAll('[data-reischl-direct-inquiry]')];
    if (root.matches?.('[data-reischl-direct-inquiry]')) wrappers.unshift(root);
    wrappers.forEach(wrapper => {
      if (initialized.has(wrapper)) return;
      initialized.add(wrapper);
      const buttons = [...wrapper.querySelectorAll('[data-reischl-method]')];
      const panels = [...wrapper.querySelectorAll('[data-reischl-panel]')];
      const service = wrapper.querySelector('[data-reischl-service]')?.dataset.reischlService || '';
      const discoverForms = () => {
        const hosts = [...wrapper.querySelectorAll('shopify-forms-embed')];
        hosts.forEach(host => adaptNativeForm(host, service));
        if (hosts.length === panels.length) hostObserver.disconnect();
      };
      const hostObserver = new MutationObserver(discoverForms);
      hostObserver.observe(wrapper, { childList:true, subtree:true });
      discoverForms();
      setTimeout(() => hostObserver.disconnect(), 15000);
      buttons.forEach(button => button.addEventListener('click', () => {
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        panels.forEach(panel => { panel.hidden = panel.dataset.reischlPanel !== button.dataset.reischlMethod; });
      }));

    });
  }
  window.reischlOpenInquiry = () => {
    const inline = document.querySelector('[data-reischl-direct-inquiry]');
    if (!inline) return false;
    inline.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    inline.querySelector('[data-reischl-method]')?.focus({ preventScroll: true });
    return true;
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
